var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('former-button',{staticClass:"navigation-button",attrs:{"icon":_vm.icon,"padded":"","size":"medium","color":_vm.color || 'gray',"href":_vm.href,"iconed":_vm.iconed},on:{"click":_vm.click}},[_vm._v("\n  "+_vm._s(_vm.label)+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }